import { apiClient } from '../../../platform/api/apiClient';

export const equipmentService = {
    getCategories() {
        return apiClient.get('equipment/categories');
    },

    getSpecifications(categoryId) {
        return apiClient.get(`equipment/specifications/${categoryId}`);
    },

    getBrandsByCategory(categoryId) {
        return apiClient.get(`brand/category/${categoryId}`);
    },

    createBrand(payload) {
        return apiClient.post('brand', {
            json: payload
        });
    },

    getUserEquipment(userId) {
        return apiClient.get(`equipment/user/${userId}`);
    },

    getUserFirearms() {
        return apiClient.get('equipment/user-firearms');
    },

    addEquipment(payload) {
        return apiClient.post('equipment/add', {
            json: payload
        });
    },

    updateEquipment(equipmentId, payload) {
        return apiClient.put(`equipment/${equipmentId}`, {
            json: payload
        });
    },

    deleteEquipment(equipmentId) {
        return apiClient.del(`equipment/${equipmentId}`);
    },

    getFirearmCertificates() {
        return apiClient.get('firearm-certificates');
    },

    createFirearmCertificate(payload) {
        return apiClient.post('firearm-certificates', {
            json: payload
        });
    },

    deleteFirearmCertificate(certificateId) {
        return apiClient.del(`firearm-certificates/${certificateId}`);
    },

    getAmmunitionLogs() {
        return apiClient.get('ammunition-logs');
    },

    createAmmunitionLog(payload) {
        return apiClient.post('ammunition-logs', {
            json: payload
        });
    },

    deleteAmmunitionLog(ammunitionLogId) {
        return apiClient.del(`ammunition-logs/${ammunitionLogId}`);
    },

    getEquipmentServices() {
        return apiClient.get('equipment-services');
    },

    createEquipmentService(payload) {
        return apiClient.post('equipment-services', {
            json: payload
        });
    },

    deleteEquipmentService(serviceId) {
        return apiClient.del(`equipment-services/${serviceId}`);
    }
};
